import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  class: "col-4",
  style: {"margin-bottom":"1em"}
}
const _hoisted_3 = {
  key: 0,
  class: "card card-body"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-5" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "mt-2 text-muted"
}
const _hoisted_13 = {
  key: 1,
  class: "d-flex gap-2 align-items-center"
}
const _hoisted_14 = {
  class: "col-sm-3",
  style: {"padding-left":"2em"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = {
  key: 0,
  style: {"margin-bottom":"1em"}
}
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("p", null, [
      _createTextVNode(" This page displays information from the Balena API. For more detailed device information use the "),
      _createElementVNode("a", { href: "https://dashboard.balena-cloud.com" }, "Balena Dashboard.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.balenaLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("h5", null, "Balena Login", -1)),
            (_ctx.balenaLoginError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.balenaLoginError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFleet) = $event)),
                  disabled: _ctx.balenaFleets.length === 0
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balenaFleets, (f) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: f,
                      value: f
                    }, _toDisplayString(f), 9, _hoisted_8))
                  }), 128))
                ], 8, _hoisted_7), [
                  [_vModelSelect, _ctx.selectedFleet]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.balenaApiToken) = $event)),
                  placeholder: "Balena API token",
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, _ctx.balenaApiToken]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.balenaLogin && $setup.balenaLogin(...args))),
                  disabled: !_ctx.selectedFleet || !_ctx.balenaApiToken
                }, " Login to Balena ", 8, _hoisted_11)
              ])
            ]),
            (_ctx.balenaFleets.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No Balena fleets configured on this server."))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.load_devices()))
            }, "Reload Device List"),
            _createElementVNode("button", {
              class: "btn btn-outline-danger",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.balenaLogout()))
            }, "Logout Balena")
          ]))
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.status), 1),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
        return (_openBlock(), _createElementBlock("p", {
          key: device.UUID,
          class: _normalizeClass(["clickable", {
          online: device.IsOnline,
          offline: !device.IsOnline,
        }]),
          onClick: ($event: any) => ($setup.load_config(device))
        }, [
          _withDirectives(_createVNode(_component_vue_feather, {
            type: "wifi",
            size: "16px"
          }, null, 512), [
            [_vShow, device.IsOnline]
          ]),
          _createTextVNode(" " + _toDisplayString(device.Name), 1)
        ], 10, _hoisted_15))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.selected_device !== null)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.selected_device.Name) + " ", 1),
            (_ctx.config_toml != _ctx.original_config_toml)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-success float-end",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.save_config()))
                }, " Save "))
              : _createCommentVNode("", true),
            (_ctx.config_toml != _ctx.original_config_toml)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-outline-danger float-end",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.cancel_edit()))
                }, " Cancel "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.selected_device !== null)
        ? (_openBlock(), _createElementBlock("pre", _hoisted_18, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config_toml) = $event)),
              class: "configpane"
            }, null, 512), [
              [_vModelText, _ctx.config_toml]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "footnote" }, [
      _createTextVNode(" The device "),
      _createElementVNode("span", { class: "online" }, "online"),
      _createTextVNode("/offline status is for the Balena platform, not the Eleven-I MQTT link. The status does not update automatically - use the \"Reload Device List\" button to get up-to-date status. ")
    ], -1))
  ]))
}